//export const BaseGatewayImage = 'https://localhost:5001';
export const BaseGatewayImage = 'https://testapi2.cntt108.vn';
//const BaseGateway = 'https://localhost:5001/api/v1';
//const BaseGateway = 'http://108.108.108.51:4005/api/v1';
const BaseGateway = 'https://testapi2.cntt108.vn/api/v1';

//const BaseGatewayFromMainServer = 'http://108.108.108.52:10808';

export const  BaseGatewayClient  = 'http://interbgc.com.vn'

const BaseGatewayCrawler = 'http://crawlerapi.xecong.info';
// api chung lấy nguộn 
export const AUTH_API = {
    LOGIN_API: `${BaseGateway}/Auth/authenticate`,
    REFRESHTOKEN_API: `${BaseGateway}/Auth/refreshToken`,
    CHANGE_PASSWORD_API: `${BaseGateway}/Auth/ChangePassword`,
    FORGOT_PASSWORD: `${BaseGateway}/Auth/ForgotPassword`,
    RESET_PASSWORD: `${BaseGateway}/Auth/ResetPassword`
};

export const ACCOUNT_API = {
    GET_PAGING_ACCOUNT: `${BaseGateway}/Account/GetAllPaging`,
    ADD_ACCOUNT: `${BaseGateway}/Account/Create`,
    EDIT_ACCOUNT: `${BaseGateway}/Account/Update`,
    DELETE_ACCOUNT: `${BaseGateway}/Account/DeleteItem`,
    GET_BY_ID_ACCOUNT: `${BaseGateway}/Account/GetItem`,
    COUNT_ALL_ACCOUNT_API: `${BaseGateway}/Account/CountAllAccount`
};
export const WELCOME_API = {
    GET_PAGING_ALL: `${BaseGateway}/Welcome/GetAllByPaging`,
    ADD_ITEM: `${BaseGateway}/Welcome/Create`,
    EDIT_ITEM: `${BaseGateway}/Welcome/Update`,
    DELETE_ITEM: `${BaseGateway}/Welcome/DeleteItem`,
    GET_BY_ID: `${BaseGateway}/Welcome/GetItem`,
};
export const PROJECT_API = {
    GET_PAGING_ALL: `${BaseGateway}/Project/GetAllByPaging`,
    ADD_ITEM: `${BaseGateway}/Project/Create`,
    EDIT_ITEM: `${BaseGateway}/Project/Update`,
    DELETE_ITEM: `${BaseGateway}/Project/DeleteItem`,
    GET_BY_ID: `${BaseGateway}/Project/GetItem`,
};
export const FILE_MANAGER_API = {
    UPLOAD: `${BaseGateway}/FileManager/Upload`,
    GET_PAGING: `${BaseGateway}/FileManager/GetAllByPaging`,
    GET_DIR_PATH: `${BaseGateway}/FileManager/GetDirectoryPath`,
    DELETE: `${BaseGateway}/FileManager`
};

export const EMAILCONFIG_API = {
    GET_PAGING_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetAllByPaging`,
    GET_ITEM_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetItem`,
    ADD_EMAILCONFIG: `${BaseGateway}/EmailConfig/CreateEmailConfig`,
    UPDATE_EMAILCONFIG: `${BaseGateway}/EmailConfig/UpdateItem`,
    DELETE_EMAILCONFIG: `${BaseGateway}/EmailConfig/DeleteItem`
};

export const BAOCAO_API = {
    GET_BAOCAO_PHANMEM: `${BaseGateway}/GiamSatChinhSuaPhanMem/GetThongKeDeNghi`,
    GET_BAOCAO_PHANMEM_NOIDUNG_THUONGGAP: `${BaseGateway}/GiamSatChinhSuaPhanMem/GetThongKeChinhSuaNoiDungPhoBien`,
    GET_BAOCAO_PHANMEM_LYDO_THUONGGAP: `${BaseGateway}/GiamSatChinhSuaPhanMem/GetThongKeChinhSuaLyDoPhoBien`,
    GET_BAOCAO_PHANMEM_SLDN: `${BaseGateway}/GiamSatChinhSuaPhanMem/GetThongKeDeNghiTheoNgay`,
    GET_BAOCAO_DULIEUBENHVIEN: `${BaseGateway}/GiamSatChinhSuaDuLieuBenhVien/GetThongKeDeNghi`,
    GET_BAOCAO_SOTIENCHENHLECH_DLBV: `${BaseGateway}/GiamSatChinhSuaDuLieuBenhVien/GetSoTienChenhLechTheoNgay`,
    GET_BAOCAO_DONVIDENGHI_TANSUAT: `${BaseGateway}/GiamSatChinhSuaDuLieuBenhVien/GetDonViTanSuat`,
    GET_BAOCAO_DULIEUBENHVIEN_NOIDUNG_PHOBIEN: `${BaseGateway}/GiamSatChinhSuaDuLieuBenhVien/GetThongKeChinhSuaNoiDungPhoBien`,
    GET_BAOCAO_DULIEUBENHVIEN_LYDO_PHOBIEN: `${BaseGateway}/GiamSatChinhSuaDuLieuBenhVien/GetThongKeChinhSuaLyDoPhoBien`,
    GET_BAOCAO_DULIEUBENHVIEN_SLDN: `${BaseGateway}/GiamSatChinhSuaDuLieuBenhVien/GetThongKeDeNghiTheoNgay`,
    GET_BAOCAO_NOIDUNG_DONVI_TANSUAT: `${BaseGateway}/GiamSatChinhSuaDuLieuBenhVien/GetNoiDungDonViTanSuat`,
    GET_BAOCAO_CHINHSUABAOHIEM_LINE: `${BaseGateway}/ChinhSuaBaoHiem/GetThongKeBaoHiemTheoNgay`,
    GET_BAOCAO_SOLUONG: `${BaseGateway}/SoLuongBaoCao/GetCountReport`,
    GET_BAOCAO_SOLUONG_DONUT: `${BaseGateway}/SoLuongBaoCao/GetCountReportDonut`,
    GET_BAOCAO_SOLUONG_LINE: `${BaseGateway}/SoLuongBaoCao/GetCountReportMethodLine`,
    GET_BAOCAO_SOLUONG_CANCEL_LINE: `${BaseGateway}/SoLuongBaoCao/GetCountCancelMethodLine`,
    GET_BAOCAO_SOLUONG_CANCEL: `${BaseGateway}/SoLuongBaoCao/GetCountCancelReport`,
    GET_BAOCAO_SOLUONG_TRALAI: `${BaseGateway}/SoLuongBaoCao/GetCountTraLaiMethodLine`,
    GET_BAOCAO_THONGKE_TRALAI: `${BaseGateway}/SoLuongBaoCao/GetCountTraLaiReport`
};

export const LOGIN_HISTORY_API = {
    GET_PAGING_LOGIN: `${BaseGateway}/LoginHistory/GetAllPaging`,
    STATISTIC_LOGIN: `${BaseGateway}/LoginHistory/GetStatisticsLoginByAccount`,
    STATISTIC_COUNT_LOGIN_BY_DATE: `${BaseGateway}/LoginHistory/CountAllByDate`
};

export const LOG_API = {
    GET_PAGING_LOG: `${BaseGateway}/Log/GetAllByPaging`,
    DELETE_LOG: `${BaseGateway}/Log/DeleteByDate`,
    COUNT_LOG_BY_DATE: `${BaseGateway}/Log/CountLogsByDate`,
};

// =========================================================================
// LECTURER CV & SCIENCE PROFILE APIS (PHỤ LỤC 02)
// =========================================================================

export const DON_VI_API = {
    GET_PAGING:    `${BaseGateway}/DonVi/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/DonVi/GetItem/{id}`,
    ADD_ITEM:      `${BaseGateway}/DonVi/Create`,
    EDIT_ITEM:     `${BaseGateway}/DonVi/UpdateItem/{id}`,
    DELETE_ITEM:   `${BaseGateway}/DonVi/DeleteItem/{id}`,
};

export const NHAN_VIEN_API = {
    GET_PAGING:    `${BaseGateway}/NhanVien/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/NhanVien/GetItem`,
    ADD_ITEM:      `${BaseGateway}/NhanVien/Create`,
    EDIT_ITEM:     `${BaseGateway}/NhanVien/UpdateItem`,
    DELETE_ITEM:   `${BaseGateway}/NhanVien/DeleteItem`,
    GET_HOSO_CV:   `${BaseGateway}/NhanVien/GetHoSoCV`, // Lấy trọn gói hồ sơ CV để in ấn
    TOGGLE_ACTIVE: `${BaseGateway}/NhanVien/ToggleActive`,
};

export const QUA_TRINH_DAO_TAO_API = {
    GET_PAGING:    `${BaseGateway}/QuaTrinhDaoTao/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/QuaTrinhDaoTao/GetItem`,
    ADD_ITEM:      `${BaseGateway}/QuaTrinhDaoTao/Create`,
    EDIT_ITEM:     `${BaseGateway}/QuaTrinhDaoTao/UpdateItem`,
    DELETE_ITEM:   `${BaseGateway}/QuaTrinhDaoTao/DeleteItem`,
};

export const NGOAI_NGU_API = {
    GET_PAGING:    `${BaseGateway}/NgoaiNgu/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/NgoaiNgu/GetItem`,
    ADD_ITEM:      `${BaseGateway}/NgoaiNgu/Create`,
    EDIT_ITEM:     `${BaseGateway}/NgoaiNgu/UpdateItem`,
    DELETE_ITEM:   `${BaseGateway}/NgoaiNgu/DeleteItem`,
};

export const BAI_BAO_API = {
    GET_PAGING:    `${BaseGateway}/BaiBao/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/BaiBao/GetItem`,
    ADD_ITEM:      `${BaseGateway}/BaiBao/Create`,
    EDIT_ITEM:     `${BaseGateway}/BaiBao/UpdateItem`,
    DELETE_ITEM:   `${BaseGateway}/BaiBao/DeleteItem`,
    APPROVE:       `${BaseGateway}/BaiBao/Approve`,
    REJECT:        `${BaseGateway}/BaiBao/Reject`,
    REVOKE:        `${BaseGateway}/BaiBao/Revoke`,
};

export const DE_TAI_NHAN_VIEN_API = {
    GET_PAGING:    `${BaseGateway}/DeTaiNhanVien/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/DeTaiNhanVien/GetItem`,
    ADD_ITEM:      `${BaseGateway}/DeTaiNhanVien/Create`,
    EDIT_ITEM:     `${BaseGateway}/DeTaiNhanVien/UpdateItem`,
    DELETE_ITEM:   `${BaseGateway}/DeTaiNhanVien/DeleteItem`,
    APPROVE:       `${BaseGateway}/DeTaiNhanVien/Approve`,
    REJECT:        `${BaseGateway}/DeTaiNhanVien/Reject`,
    REVOKE:        `${BaseGateway}/DeTaiNhanVien/Revoke`,
};

export const SANG_CHE_API = {
    GET_PAGING:    `${BaseGateway}/SangChe/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/SangChe/GetItem`,
    ADD_ITEM:      `${BaseGateway}/SangChe/Create`,
    EDIT_ITEM:     `${BaseGateway}/SangChe/UpdateItem`,
    DELETE_ITEM:   `${BaseGateway}/SangChe/DeleteItem`,
    APPROVE:       `${BaseGateway}/SangChe/Approve`,
    REJECT:        `${BaseGateway}/SangChe/Reject`,
    REVOKE:        `${BaseGateway}/SangChe/Revoke`,
};

export const GIAI_THUONG_API = {
    GET_PAGING:    `${BaseGateway}/GiaiThuong/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/GiaiThuong/GetItem`,
    ADD_ITEM:      `${BaseGateway}/GiaiThuong/Create`,
    EDIT_ITEM:     `${BaseGateway}/GiaiThuong/UpdateItem`,
    DELETE_ITEM:   `${BaseGateway}/GiaiThuong/DeleteItem`,
    APPROVE:       `${BaseGateway}/GiaiThuong/Approve`,
    REJECT:        `${BaseGateway}/GiaiThuong/Reject`,
    REVOKE:        `${BaseGateway}/GiaiThuong/Revoke`,
};

export const SACH_API = {
    GET_PAGING:    `${BaseGateway}/Sach/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/Sach/GetItem`,
    ADD_ITEM:      `${BaseGateway}/Sach/Create`,
    EDIT_ITEM:     `${BaseGateway}/Sach/UpdateItem`,
    DELETE_ITEM:   `${BaseGateway}/Sach/DeleteItem`,
    APPROVE:       `${BaseGateway}/Sach/Approve`,
    REJECT:        `${BaseGateway}/Sach/Reject`,
    REVOKE:        `${BaseGateway}/Sach/Revoke`,
};

export const HUONG_DAN_HOC_VIEN_API = {
    GET_PAGING:    `${BaseGateway}/HuongDanHocVien/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/HuongDanHocVien/GetItem`,
    ADD_ITEM:      `${BaseGateway}/HuongDanHocVien/Create`,
    EDIT_ITEM:     `${BaseGateway}/HuongDanHocVien/UpdateItem`,
    DELETE_ITEM:   `${BaseGateway}/HuongDanHocVien/DeleteItem`,
    APPROVE:       `${BaseGateway}/HuongDanHocVien/Approve`,
    REJECT:        `${BaseGateway}/HuongDanHocVien/Reject`,
    REVOKE:        `${BaseGateway}/HuongDanHocVien/Revoke`,
};

export const GIAI_THUONG_DAO_TAO_API = {
    GET_PAGING:    `${BaseGateway}/GiaiThuongDaoTao/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/GiaiThuongDaoTao/GetItem`,
    ADD_ITEM:      `${BaseGateway}/GiaiThuongDaoTao/Create`,
    EDIT_ITEM:     `${BaseGateway}/GiaiThuongDaoTao/UpdateItem`,
    DELETE_ITEM:   `${BaseGateway}/GiaiThuongDaoTao/DeleteItem`,
    APPROVE:       `${BaseGateway}/GiaiThuongDaoTao/Approve`,
    REJECT:        `${BaseGateway}/GiaiThuongDaoTao/Reject`,
    REVOKE:        `${BaseGateway}/GiaiThuongDaoTao/Revoke`,
};

export const HOC_VI_API = {
    GET_PAGING:    `${BaseGateway}/HocVi/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/HocVi/GetItem/{id}`,
    ADD_ITEM:      `${BaseGateway}/HocVi/Create`,
    EDIT_ITEM:     `${BaseGateway}/HocVi/UpdateItem/{id}`,
    DELETE_ITEM:   `${BaseGateway}/HocVi/DeleteItem/{id}`,
};

export const CHUC_DANH_KHOA_HOC_API = {
    GET_PAGING:    `${BaseGateway}/ChucDanhKhoaHoc/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/ChucDanhKhoaHoc/GetItem/{id}`,
    ADD_ITEM:      `${BaseGateway}/ChucDanhKhoaHoc/Create`,
    EDIT_ITEM:     `${BaseGateway}/ChucDanhKhoaHoc/UpdateItem/{id}`,
    DELETE_ITEM:   `${BaseGateway}/ChucDanhKhoaHoc/DeleteItem/{id}`,
};

export const CHUC_VU_API = {
    GET_PAGING:    `${BaseGateway}/ChucVu/GetAllByPaging`,
    GET_BY_ID:     `${BaseGateway}/ChucVu/GetItem/{id}`,
    ADD_ITEM:      `${BaseGateway}/ChucVu/Create`,
    EDIT_ITEM:     `${BaseGateway}/ChucVu/UpdateItem/{id}`,
    DELETE_ITEM:   `${BaseGateway}/ChucVu/DeleteItem/{id}`,
};